import { GetAccountsResponse } from '@iwoca/lapi-client/edge';
import { TDuration } from '../../mapOfferDurationToMonths';

export const mapDurationToSellerProduct = ({
    duration
}: {
    duration: NonNullable<
        GetAccountsResponse['data']
    >['accounts'][number]['duration'];
}) => {
    const durationInMonths = mapDurationToMonths(duration);

    switch (durationInMonths) {
        case 3:
            return 'THREE_MONTHS';
        case 12:
            return 'TWELVE_MONTHS';
        default:
            return null;
    }
};

const mapDayDurationToMonths = (
    duration: NonNullable<
        NonNullable<GetAccountsResponse['data']>['accounts'][number]['duration']
    >
) => {
    switch (duration.amount) {
        case 91:
            return 3;
        case 365:
            return 12;
        default:
            return null;
    }
};

const mapYearDurationToMonths = (
    duration: NonNullable<
        NonNullable<GetAccountsResponse['data']>['accounts'][number]['duration']
    >
) => {
    switch (duration.amount) {
        case 1:
            return 12;
        default:
            return null;
    }
};

const mapDurationToMonths = (
    duration: NonNullable<
        GetAccountsResponse['data']
    >['accounts'][number]['duration']
) => {
    if (!duration) return null;

    switch (duration.unit) {
        case 'days':
            return mapDayDurationToMonths(duration);
        case 'years':
            return mapYearDurationToMonths(duration);
    }

    return duration?.amount as TDuration;
};
